/* eslint-disable */
import { FormLabel, makeStyles, Typography, MenuItem } from '@material-ui/core'
import { FC, useRef, useState } from 'react'
import Select, { StylesConfig } from 'react-select'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

const useStyles = makeStyles({
  radios: {
    paddingTop: '0.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '-5px',
    marginLeft: '-5px',
    marginRight: '-5px',
    '& > div': {
      fontFamily: 'CircularRegular',
      fontSize: '12px',
      lineHeight: '30px',
      borderRadius: '6px',
      backgroundColor: 'rgb(243, 243, 243)', // 'lightgray',
      flexWrap: 'wrap',
      color: 'darkgray',
      flex: '1 0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '25%',
      margin: '5px',
      padding: '4px 8px',
      boxSizing: 'border-box',
      textAlign: 'center',
      cursor: 'pointer'
    },
    '& > div.active': {
      backgroundColor: '#4f9b44', // 'cornflowerblue',
      color: 'white'
    }
  },
  AppsRadios: {
    paddingTop: '0.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '-5px',
    marginLeft: '-5px',
    marginRight: '-5px',
    '& > div': {
      fontFamily: 'CircularRegular',
      fontSize: '13px',
      borderRadius: '6px',
      backgroundColor: '#E7ECEF', // 'lightgray',
      flexWrap: 'wrap',
      color: 'rgba(0, 0, 0, 0.87)',
      flex: '1 0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '25%',
      height: '58px',
      margin: '5px',
      padding: '4px 8px',
      boxSizing: 'border-box',
      textAlign: 'center',
      cursor: 'pointer',
      '&:hover': {
        background: '#FBF6EE'
      }
    },
    '& > div.active': {
      backgroundColor: '#4f9b44', // 'cornflowerblue',
      color: 'white',
      '&:hover': {
        backgroundColor: '#4f9b44'
      }
    }
  },
  helperText: {
    color: '#0000008a',
    fontFamily: 'Arial',
    fontSize: '0.75rem'
  },
  inputIcon: {
    position: 'absolute',
    color: '#A9B0B5',
    top: '12px',
    right: '20px'
  },
  input: {
    // e4e0e0 disabled
    position: 'relative',
    '& label': {
      display: 'inline-block',
      paddingBottom: '0.5rem',
      fontSize: '10px',
      fontWeight: '600',
      color: 'rgb(111, 168, 220)'
    },
    '&:disabled': {
      backgroundColor: '#e4e0e0'
    },
    '& input': {
      padding: '0 5px',
      height: '30px',
      boxSizing: 'border-box',
      border: '1px solid rgb(232, 232, 232)',
      borderRadius: '6px',
      backgroundColor: 'rgb(243, 243, 243)',
      fontFamily: 'CircularRegular',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
      }
    },
    '& p': {
      margin: '0',
      fontSsize: '0.75rem',
      marginTop: '3px',
      textAlign: 'left',
      fontFamily: 'CircularRegular',
      fontWeight: '400',
      lineHeight: '1.66',
      letterSpacing: '0.03333em'
    }
  },
  select: {
    // reseting default styles
    // width: '100%',
    // fontSsize: '0.75rem',
    // lineHeight: '1.66',
    // letterSpacing: '0.03333em',
    // fontFamily: 'CircularRegular',
    // //overriding

    // padding: '0 5px',
    // height: '30px',
    // boxSizing: 'border-box',
    // border: '1px solid rgb(232, 232, 232)',
    borderRadius: '6px',
    backgroundColor: 'rgb(243, 243, 243)'
  },
  textArea: {
    maxWidth: '100%',
    resize: 'vertical',
    '& label': {
      display: 'block',
      marginBottom: '8px'
    },
    '& textarea': {
      minHeight: '96px',
      padding: '10px 12px',
      boxSizing: 'border-box',
      border: '1px solid rgb(232, 232, 232)',
      borderRadius: '6px',
      backgroundColor: 'rgb(243, 243, 243)',
      minWidth: '100%',
      width: '100%',
      maxWidth: '100%',
      '&::after': {
        content: 'none !important'
      },
      resize: 'vertical',
      wrap: 'soft'
    },
    '& > p': {
      margin: '0',
      fontSsize: '0.75rem',
      marginTop: '3px',
      textAlign: 'left',
      fontFamily: 'CircularRegular',
      fontWeight: '400',
      lineHeight: '1.66',
      letterSpacing: '0.03333em'
    }
  },
  redioButtonsField: {
    '& label': {
      fontSize: '10px',
      fontWeight: '600',
      color: 'rgb(111, 168, 220)'
    },
    '& > span': {
      margin: '0',
      fontSsize: '0.75rem',
      marginTop: '3px',
      textAlign: 'left',
      fontFamily: 'CircularRegular',
      fontWeight: '400',
      lineHeight: '1.66',
      letterSpacing: '0.03333em'
    }
  },
  error: {
    display: 'block',
    marginTop: '-4px',
    fontSize: '11px',
    color: 'red',
  },
  uploadError: {
    display: 'block',
    fontSize: '11px',
    color: 'red',
    fontFamily: 'CircularRegular',
    marginTop: '0.5rem',
    lineHeight: '1.5'
  },
  noOptionsMessage: {
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center'
  },
  fileUploadButton: {
    //paddingTop: '0.5rem',
    display: 'flex',
    marginTop: '1px',
    marginBottom: '1px',
    // marginLeft: '-5px',
    // marginRight: '-5px',
    fontFamily: 'CircularRegular',
    fontSize: '12px',
    lineHeight: '30px',
    borderRadius: '6px',
    backgroundColor: 'rgb(243, 243, 243)', // 'lightgray',
    flexWrap: 'wrap',
    color: 'darkgray',
    flex: '1 0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    //width: '25%',
    //margin: '5px',
    padding: '4px 8px',
    boxSizing: 'border-box',
    textAlign: 'center',
    cursor: 'pointer',
    boxShadow: 'none',
    border: 'none',
    width: '100%'
  },
  saveCropButton: {
    display: 'flex',
    marginTop: '1px',
    marginBottom: '1px',
    fontFamily: 'CircularRegular',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    lineHeight: '30px',
    borderRadius: '6px',
    backgroundColor: '#4f9b44', // 'lightgray',
    flexWrap: 'wrap',
    color: 'white',
    flex: '1 0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 8px',
    boxSizing: 'border-box',
    textAlign: 'center',
    cursor: 'pointer',
    boxShadow: 'none',
    border: 'none',
    width: '100%'
  },
  imageContainer: {
    marginTop: '1rem',
    maxWidth: 500, // Adjust as needed 
    // maxHeight: 400,
    //overflow: 'hidden'
  }
})

const selectStyles: StylesConfig<any> = {
  option: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
          ? 'rgb(231, 236, 239)'
          : isFocused
            ? 'rgb(231, 236, 239)'
            : undefined,
      cursor: isDisabled ? 'not-allowed' : 'default',
      color: '#000'
    }
  },
  input: (styles: any) => ({
    ...styles,
    fontFamily: 'CircularRegular'
  }),
  valueContainer: (styles: any) => ({
    ...styles,
    fontFamily: 'CircularRegular'
  })
}

export const MyRadio: FC<any> = ({ input, meta, items, ...props }) => {
  const styles = useStyles()
  return (
    <div className={styles.redioButtonsField}>
      {props.label && (
        <FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>
      )}
      <div className={styles.radios}>
        {items.map(([key, title]: [string, string]) => (
          <div
            onClick={() => {
              input.onChange(key)
              input.onBlur()
              if (typeof props.extraChange === 'function') {
                props.extraChange(key)
              }
            }}
            key={key}
            style={props.style || {}}
            className={(key === input.value && 'active') || ''}
          >
            {title}
          </div>
        ))}
      </div>
      {(meta.touched || meta.submitFailed) && meta.error && (
        <span className={styles.uploadError}>{meta.error}</span>
      )}
    </div>
  )
}
export const MyApartmentRadio: FC<any> = ({ input, meta, items, ...props }) => {
  const styles = useStyles()

  return (
    <div className={styles.redioButtonsField}>
      {props.label && (
        <FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>
      )}
      <div className={styles.AppsRadios}>
        {items.map(([key, title]: [string, string]) => (
          <div
            onClick={() => {
              input.onChange(key)
              input.onBlur()
              if (typeof props.extraChange === 'function') {
                props.extraChange(key)
              }
            }}
            key={key}
            style={props.style || {}}
            className={(key === input.value && 'active') || ''}
          >
            {title}
          </div>
        ))}
      </div>
      {(meta.touched || meta.submitFailed) && meta.error && (
        <span className={styles.error}>{meta.error}</span>
      )}
    </div>
  )
}

export const MyCheckboxes: FC<any> = ({ input, meta, items, ...props }) => {
  const styles = useStyles()

  return (
    <>
      <div className={styles.radios}>
        {items.map(([key, title]: [string, string]) => (
          <div
            onClick={() => {
              const newNalue = new Set(
                Array.isArray(input.value) ? input.value : []
              )
              if (newNalue.has(key)) {
                newNalue.delete(key)
              } else {
                newNalue.add(key)
              }
              input.onChange([...newNalue])
            }}
            key={key}
            className={
              (Array.isArray(input.value) &&
                input.value.includes(key) &&
                'active') ||
              ''
            }
          >
            {title}
          </div>
        ))}
      </div>
      {meta.touched && meta.error && (
        <span className={styles.error}>{meta.error}</span>
      )}
    </>
  )
}

export const MyInput: FC<any> = ({ input, meta, items, ...props }) => {
  const styles = useStyles()
  return (
    <div className={styles.input}>
      {props.label && (
        <FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>
      )}
      <input
        // onChange={(e) => {
        //   input.onChange(e.target.value)
        // }}
        id={`field-${input.name}`}
        className={styles.input}
        onChange={input.onChange}
        type={props.type}
        placeholder={props.placeholder}
        style={props.style}
        onBlur={input.onBlur}
        onKeyDown={props.onKeyDown}
        autoComplete={props.autoComplete}
        inputMode={props.inputMode}
        value={
          typeof input.value !== 'object' ? input.value : input.value.label
        }
        disabled={props.disabled}
      // className={meta.touched && meta.error ? styles.error : ''}
      // helperText={
      //   meta.touched && meta.error ? meta.touched && meta.error : '' // custom.helperText
      // }
      />
      {props?.InputIcon && (
        <p className={styles.inputIcon}>{props.InputIcon}</p>
      )}
      {props?.helperText && (
        <p className={styles.helperText}>{props.helperText}</p>
      )}
      {(meta.touched || meta.submitFailed) && meta.error && (
        <Typography variant='body1' className={styles.error}>
          {meta.error}
        </Typography>
      )}
    </div>
  )
}
export const MySelect: FC<any> = ({
  input,
  children,
  meta,
  items,
  ...props
}) => {
  const styles = useStyles()
  return (
    <div className={styles.input}>
      {props.label && (
        <FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>
      )}
      <select
        id={`field-${input.name}`}
        className={styles.select}
        onChange={input.onChange}
        style={props.style}
        onBlur={input.onBlur}
        value={input.value}
        disabled={props.disabled}
      >
        <option value='' disabled hidden></option>
        {children.map((el: any, i: number) => {
          return (
            <option value={el?.props?.value} key={i}>
              {el?.props?.children}
            </option>
          )
        })}
      </select>
      {props?.helperText && (
        <p className={styles.helperText}>{props.helperText}</p>
      )}
      {(meta.touched || meta.submitFailed) && meta.error && (
        <Typography variant='body1' className={styles.error}>
          {meta.error}
        </Typography>
      )}
    </div>
  )
}

export const MySelectWithInput: FC<any> = ({
  input,
  children,
  meta,
  items,
  ...props
}) => {
  const styles = useStyles()
  return (
    <div className={styles.input}>
      {props.label && (
        <FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>
      )}
      <input
        list={`field-${input.name}`}
        onChange={input.onChange}
        className={styles.select}
        style={props.style}
        value={input.value}
        onBlur={input.onBlur}
      />
      <datalist id={`field-${input.name}`}>
        <option value='' disabled hidden></option>
        {children.map((el: any, i: number) => {
          return (
            <option value={el?.props?.value} key={i}>
              {el?.props?.children}
            </option>
          )
        })}
      </datalist>
      {props?.helperText && (
        <p className={styles.helperText}>{props.helperText}</p>
      )}
      {(meta.touched || meta.submitFailed) && meta.error && (
        <Typography variant='body1' className={styles.error}>
          {meta.error}
        </Typography>
      )}
    </div>
  )
}

const NoOptionsMessage: FC<any> = ({
  selectProps,
  innerProps,
  children,
  ...props
}) => {
  const styles = useStyles()
  return (
    <Typography
      variant='body1'
      className={styles.noOptionsMessage}
      {...innerProps}
    >
      {children}
    </Typography>
  )
}

const Option: FC<any> = ({
  innerRef,
  isFocused,
  isSelected,
  innerProps,
  children,
  ...props
}) => {
  return (
    <MenuItem
      buttonRef={innerRef}
      selected={isFocused}
      component='div'
      style={{
        fontWeight: isSelected ? 500 : 400
      }}
      {...innerProps}
    >
      {children}
    </MenuItem>
  )
}

const IndicatorSeparator: FC<any> = () => null

export const ReduxFormSelect: FC<any> = ({
  input,
  children,
  meta,
  items,
  options,
  ...props
}) => {
  const styles = useStyles()
  const components = {
    IndicatorSeparator,
    NoOptionsMessage,
    Option
  }
  const [isFieldChanged, setFieldChanged] = useState(false);
  // A saved value that is not among the options shows its error right away
  const hasInvalidSavedValue = meta.pristine && !!meta.initial
  return (
    <div className={styles.input}>
      {props.label && (
        <FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>
      )}
      <Select
        {...input}
        // Controlled even when empty, so react-select never shows options[0] as if it were chosen
        value={input.value ?? null}
        onChange={(event) => {
          //setFieldChanged(true);
          input.onChange(event);
        }}
        onBlur={(event) => {
          event.preventDefault()
          setFieldChanged(true);
        }}
        options={options}
        isSearchable
        styles={{
          ...selectStyles,
          control: (baseStyles) => ({
            ...baseStyles,
            backgroundColor: props.backgroundColor
              ? props.backgroundColor
              : '#E7ECEF',
            border: 'none',
            height: '58px'
          })
        }}
        placeholder={props.placeholder || ''}
        components={components}
        classNamePrefix='react-select'
      />
      {(isFieldChanged || meta.submitFailed || meta.dirty || hasInvalidSavedValue) && meta.error && (
        <Typography variant='body1' className={styles.error}>
          {meta.error}
        </Typography>
      )}
    </div>
  )
}

export const MyTextArea: FC<any> = ({ input, meta, items, ...props }) => {
  const styles = useStyles()
  return (
    <div className={styles.textArea}>
      {props.label && (
        <FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>
      )}
      <textarea
        id={`field-${input.name}`}
        className={styles.input}
        onChange={input.onChange}
        placeholder={props.placeholder}
        style={props.style}
        onBlur={input.onBlur}
        value={input.value}
        disabled={props.disabled}
      />
      {meta.touched && meta.error && (
        <Typography variant='body1' className={styles.error}>
          {meta.error}
        </Typography>
      )}
    </div>
  )
}

export const ImageUploadButton: FC<any> = ({ input, uploadText, changeText, saveText, uploadErrorText, meta }) => {
  const styles = useStyles();
  const [imageSrc, setImageSrc] = useState<string | ArrayBuffer | null>(null);
  const [crop, setCrop] = useState<ReactCrop.Crop>({});
  const [croppedImage, setCroppedImage] = useState<Blob | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [croppingDone, setCroppingDone] = useState(false);
  const [uploadError, setUploadError] = useState(false);

  const handleClick = () => {
    event?.preventDefault();
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const image = new Image();
        image.onload = () => {
          if (image.width < 200 || image.height < 200) {
            //alert('Image dimensions must be at least 200x200 pixels.');
            setImageSrc(null);
            setCroppedImage(null);
            setUploadError(true)
            return;
          }
          setUploadError(false)
          setCroppingDone(false)
          setImageSrc(reader.result);
          const aspectRatio = image.width / image.height;
          setCrop({
            aspect: aspectRatio,
            unit: 'px',
            width: 200, // Initial crop size
            height: 200,
            x: 0,
            y: 0
          });
        };
        image.src = reader.result as string;
      };
      reader.readAsDataURL(file);
    } else {
      setImageSrc(null);
      setCroppedImage(null);
    }
  };

  // const handleCropComplete = (crop) => {
  //   setCrop(crop);
  //   // No automatic cropping here, wait for user action
  // };

  const handleFinalCrop = () => {
    event?.preventDefault();
    makeClientCrop(crop);
  };

  const makeClientCrop = async (crop) => {
    if (imageSrc && crop.width && crop.height) {
      const image = new Image();
      image.src = imageSrc as string;
      await image.decode();

      const editorDisplayWidth = document.getElementById('croppable-image').clientWidth;
      const editorDisplayHeight = document.getElementById('croppable-image').clientHeight;

      const scaleX = image.naturalWidth / editorDisplayWidth;
      const scaleY = image.naturalHeight / editorDisplayHeight;

      const pixelCrop = {
        x: crop.x * scaleX,
        y: crop.y * scaleY,
        width: crop.width * scaleX,
        height: crop.height * scaleY,
      };

      const croppedImageUrl = await getCroppedImg(imageSrc, pixelCrop, 500, 500);
      const croppedImageBlob = dataURLtoBlob(croppedImageUrl as string);
      setCroppingDone(true)
      setCroppedImage(croppedImageBlob);
      input.onChange(croppedImageBlob);
    }
  };

  const getCroppedImg = (imageSrc, pixelCrop, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc as string;

      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = Math.min(pixelCrop.width, maxWidth);
        canvas.height = Math.min(pixelCrop.height, maxHeight);
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            canvas.width,
            canvas.height
          );
          resolve(canvas.toDataURL('image/jpeg'));
        } else {
          reject(new Error('Unable to get canvas context'));
        }
      };

      image.onerror = () => {
        reject(new Error('Image loading failed'));
      };
    });
  };

  // Converts a data URL to a Blob
  const dataURLtoBlob = (dataUrl: string) => {
    const parts = dataUrl.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  };

  return (
    <div>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
      <button onClick={handleClick} className={styles.fileUploadButton}>
        {imageSrc ? changeText : uploadText}
      </button>
      {uploadError && (
        <span className={styles.uploadError}>{uploadErrorText}</span>
      )}
      {!croppingDone && imageSrc && (
        <>
          <div className={styles.imageContainer}>
            <ReactCrop
              crop={crop}
              onChange={(percentCrop) => setCrop(percentCrop)}
              circularCrop={true}
              minWidth={10}
              minHeight={10}
              aspect={1}
              keepSelection={true}
              style={{ touchAction: 'auto' }}
            >
              <img src={imageSrc as string} id="croppable-image" alt="Croppable" style={{ touchAction: 'auto' }} />
            </ReactCrop>
          </div>
          <button onClick={handleFinalCrop} className={styles.saveCropButton} style={{ marginTop: '0.5rem' }}>{saveText}</button>
        </>
      )}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {croppedImage && croppingDone && (
          <img
            src={URL.createObjectURL(croppedImage)}
            alt="Cropped"
            style={{
              marginTop: '1rem',
              maxWidth: '100%',
              borderRadius: '50%'
            }}
          />
        )}
      </div>
      {meta.touched && meta.error && (
        <Typography variant='body1' className={styles.error} style={{ marginTop: '0.5rem' }}>
          {meta.error}
        </Typography>
      )}
    </div>
  )
}
